/**
 * Allows the user to read a limited number of articles for free before being prompted to upgrade.
 */

const storeArticleVisit = (id) => {
  const visitsKey = "articleIds";
  const visits = new Set(JSON.parse(localStorage.getItem(visitsKey)) || []);
  visits.add(id);
  localStorage.setItem(visitsKey, JSON.stringify(Array.from(visits)));
};

const getArticleVisits = () => {
  const visitsKey = "articleIds";
  const articleIds = JSON.parse(localStorage.getItem(visitsKey)) || [];
  return articleIds.length;
};

export const initArticleVisits = () => {
  // Only initialize article visits for public articles.
  const upgradeCta = document.querySelector(
    ".cta-overlay[data-variant='upgrade'][data-visibility='public']",
  );

  if (!upgradeCta) {
    return;
  }

  const articleReadLimit =
    parseInt(upgradeCta.dataset.articleReadLimit, 10) || 3;
  const articleId = upgradeCta.dataset.articleId;
  const articleVisits = getArticleVisits();

  if (articleVisits < articleReadLimit) {
    storeArticleVisit(articleId);
    upgradeCta.remove();
  }
};
